<template>
  <el-dialog
    :visible.sync="visible"
    top="0"
    :custom-class="deleteIds.length > 0 ? 'delete-course' : 'upload'"
    :before-close="handleClose"
    width="708px"
    center
  >
    <div slot="title" class="dialog-title tabheader" v-if="showTitle">
      <span>资料删除</span>
    </div>
    <div class="dialog-body">
      <p v-html="desc" style="padding-left: 20px; padding-right: 20px"></p>
      <p v-if="documentTitle">《{{ documentTitle }}》</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button data-io-click="tracker"  @click="handleClose" round>取消</el-button>
      <el-button data-io-click="tracker"  @click="handleDelete" type="info" :class="['submit info']"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import request from "@/utils/request";
import api from "@/assets/js/service/api";
import { mapMutations, mapState } from "vuex";
import { updateLastUsedCourse } from "@/utils/apis";
const CURRENTCOURSE = "CURRENTCOURSE";
export default {
  inject: ["textbook"],
  mixins: [],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    documentId: {
      type: Number,
      default: null,
    },
    desc: {
      type: String,
      default: "是否确定删除您上传的校本资料",
    },
    documentTitle: {
      type: String,
      default: "",
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {},
  components: {},
  mounted() {},
  computed: {
    ...mapState({
      currentCourse: "currentCourse",
      userInfo: "userInfo",
      userCourses: "userCourses",
      showUserCourse: "showUserCourse",
      deleteIds: "deleteIds",
      beforeDeleteShowUserCourse: "beforeDeleteShowUserCourse",
    }),
  },
  methods: {
    ...mapMutations({
      setCourses: "setCourses",
      setShowUserCourse: "setShowUserCourse",
      setDeleteIds: "setDeleteIds",
      setCurrentCourse: "setCurrentCourse",
    }),
    async handleDelete() {
      //调取 addCourse 的方法
      this.$emit("handleDelete");
    },
    handleClose() {
      // this.$message("取消操作");
      this.$emit("handleClose");
      this.setDeleteIds([]);
      // console.log("当前的用户课程", this.userCourses);
      this.setShowUserCourse(this.beforeDeleteShowUserCourse);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .delete-course {
  .el-dialog__header {
    border-bottom: none !important;
    height: auto;
    // .tabheader {
    //   text-align: left;
    //   font-size: 16px;
    // }
  }
  .el-dialog__body {
    padding: 0 20px;
    .dialog-body {
      p {
        i {
          font-style: normal;
          font-weight: bold;
        }
      }
    }
  }
}
.upload-btn {
  width: 490px;
  line-height: 28px;
  border: 1px dashed #0057ff;
  border-radius: 15px;
  margin-left: 0;
  margin-top: 5px;
  color: #0057ff;
  text-align: center;
  position: relative;
  font-size: 12px;
  input {
    width: 100%;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer;
  }
  .bubble-tip {
    position: absolute;
    bottom: -33px;
    background: #ff7e07;
    padding: 0 12px;
    height: 26px;
    left: 50%;
    margin-left: -60px;
    color: #fff;
    font-size: 12px;
    line-height: 26px;
    text-align: center;
    border-radius: 5px;
    &::after {
      position: absolute;
      display: block;
      content: "";
      width: 0px;
      height: 0px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #ff7e07 transparent;
      top: -9px;
      left: 50%;
      margin-left: -3px;
    }
  }
  i {
    font-size: 12px;
    margin-right: 10px;
  }
  &.disabled {
    border: 1px dashed #b6b9c0;
    color: #b6b9c0;
  }
}
.progress {
  position: absolute;
  top: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
  overflow: initial;
  overflow-x: initial;
}
.el-button {
  width: 132px;
  height: 42px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  &.submit {
    background: #0057ff;
    color: #fff;
    border: none;
    border-radius: 21px;
    cursor: pointer;
    margin-left: 30px;
    &.disabled {
      background: #7f848b;
      color: #fff;
    }
  }
}

::v-deep .el-dialog__header {
  text-align: left;
}
.clearfix {
  display: block;
}
.dialog-body {
  text-align: center;
  font-size: 14px;
  line-height: 24px;
  color: #333333;
  margin-top: 28px;
  margin-bottom: 38px;
  i {
    // text
  }
}
</style>
